module.exports = __webpack_public_path__ + "img/driveway.8ad1e973.webp";